import styled from "styled-components";
export var PaginationHolder = styled.ul.withConfig({
  displayName: "paginationstyles__PaginationHolder",
  componentId: "sc-sb82es-0"
})(["display:flex;width:fit-content;margin:0 auto;"]);